<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="pv"></a> In memory of my brother Nat</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?74bfbc1a